import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

export const selectMyWorkspace = (state: RootState) => state.workspace;

export const myWorkspaceSelector = createSelector(selectMyWorkspace, (state) => state);
